export const getRedirectUrl = (baseUrl: string): string => {
  const urlParams = new URLSearchParams(window.location.search);

  const app = urlParams.get("app") || "buyer";
  const via = urlParams.get("via");

  if (via) {
    return `${baseUrl}?app=${encodeURIComponent(app)}&via=${encodeURIComponent(
      via
    )}`;
  }

  return `${baseUrl}?app=${encodeURIComponent(app)}`;
};
